export function isArray(arr) {
    return Array.isArray(arr);
}
export function keysOf(object) {
    return Object.keys(object);
}
//# sourceMappingURL=index.js.map